(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["anima-birthday-price"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('anima-birthday-price')) {
    customElements.define('anima-birthday-price', class extends HTMLElement {
      connectedCallback() {
        this.refresh = this.refresh || (() => this.update());
        document.addEventListener('visibilitychange', this.refresh);
        window.addEventListener('pageshow', this.refresh);
        this.update();
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        document.removeEventListener('visibilitychange', this.refresh);
        window.removeEventListener('pageshow', this.refresh);
      }
      update() {
        clearTimeout(this.timer);
        const remaining = Number(this.dataset.endsAt) - Date.now();
        const offer = this.querySelector('[data-birthday-offer]');
        const standard = this.querySelector('[data-birthday-standard]');
        if (!offer || !standard) return;
        if (!Number.isFinite(remaining) || remaining <= 0) {
          offer.hidden = true;
          standard.hidden = false;
          return;
        }
        const hours = this.querySelector('[data-birthday-hours]');
        const minutes = this.querySelector('[data-birthday-minutes]');
        if (hours && minutes) {
          const totalMinutes = Math.ceil(remaining / 60000);
          hours.textContent = String(Math.floor(totalMinutes / 60)).padStart(2, '0');
          minutes.textContent = String(totalMinutes % 60).padStart(2, '0');
        }
        this.timer = setTimeout(this.refresh, Math.min(60000, remaining % 60000 || 60000));
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
